import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=23497dd4&scoped=true&"
import script from "./NavBar.vue?vue&type=script&lang=js&"
export * from "./NavBar.vue?vue&type=script&lang=js&"
import style0 from "./NavBar.vue?vue&type=style&index=0&id=23497dd4&scoped=true&lang=scss&"
import style1 from "./NavBar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23497dd4",
  null
  
)

export default component.exports